import {
  propertyCreate,
  propertyGet,
  propertyList,
  propertyUpdate,
  propertyUpdateAdminMemo,
  usePropertyCreate,
  usePropertyGetSuspense,
  usePropertyList,
  usePropertyListSuspense,
  usePropertyUpdate,
  usePropertyUpdateAdminMemo,
} from "@/api/generated/endpoints/api"
import {
  PropertyGetWithRooms,
  PropertyGetWithRoomsPlans,
  PropertyGetWithRoomsTenants,
  PropertyGetWithRoomsTenantsFiles,
} from "@/api/generated/models"
import {
  propertyCreateBody,
  propertyUpdateAdminMemoBody,
  propertyUpdateBody,
} from "@/api/generated/schemas/api.zod"

// API hooks and functions
export const propertyApi = {
  // Query hooks
  usePropertyList,
  usePropertyListSuspense,
  usePropertyGetSuspense,

  // Mutation hooks
  usePropertyCreate,
  usePropertyUpdate,
  usePropertyUpdateAdminMemo,

  // Direct API functions
  propertyCreate,
  propertyGet,
  propertyList,
  propertyUpdate,
  propertyUpdateAdminMemo,
}

export const propertyProperties = {
  PropertyGetWithRooms,
  PropertyGetWithRoomsPlans,
  PropertyGetWithRoomsTenants,
  PropertyGetWithRoomsTenantsFiles,
}

export const propertySchemas = {
  propertyCreateBody,
  propertyUpdateBody,
  propertyUpdateAdminMemoBody,
}

export * as PropertyModels from "./models"
